import moment from 'moment';

export function getCurrentOutage(outages) {
  const current = moment();
  return outages.find((outage) =>
    current.isBetween(moment(outage.ShowFrom), moment(outage.ShowTo))
  );
}

export function inOutage(outage) {
  const current = moment();
  return current.isBetween(moment(outage.From), moment(outage.To));
}

export function isFeatureDisabled(feature, area = null) {
  return portalSettings.DISABLED_FEATURES.some((disabledFeature) => {
    return (
      disabledFeature['Feature'] === feature &&
      (!area ||
        disabledFeature['Areas'].includes(area) ||
        disabledFeature['Areas'].length < 1)
    );
  });
}
